<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fm-title"><span class="bold">Acknowledgements</span></h2>
<p class="noindent">Work on this book started at the end of August 2020, just a few days after the 80th anniversary of Trotsky’s death in Mexico City, on 21 August 1940, following a dramatic and ultimately successful assassination attempt the previous day.</p>
<p class="indent">I would like to thank Jacqui Petrie, Ken and Di Barrell, Chrissie Parfitt, Ian Rycroft, Paul Wilmott, Tony Lywood – and two of my ex-History students, Nicky Barrell and Patrick Fitzgerald – for kindly reading, and offering constructive criticism on early drafts of various chapters.</p>
<p class="indent">Thanks are also due to Chris Evan Brown for shaping my proposal, and to Claire Hopkins, Laura Hirst and the rest of the team at Pen &amp; Sword for pre-publication improvements. Thanks are also due to Thomas Bohm, of Design, Illustration &amp; Typesetting, for his skill – and patience! – in drawing up the Family Tree and the various maps.</p>
<p class="indent">Any remaining faults and errors are down to me.</p>
<p class="indent">I would also like to thank our daughters, Megan and Vanessa, and our grandchildren, Alexander and Emilia, for their support and encouragement – especially over the past eleven years, and during what was a difficult year for so many.</p>
<p class="indentb">And finally, I owe a huge debt of gratitude to Cyn who, for Christmas 1972, bought me Wyndham and King’s <em class="italic">Trotsky: A Documentary</em> – which, 50 years later, helped me shape and complete this book.</p>
<p class="right">Allan Todd</p>
<p class="right">June 2021</p>
<p class="right">Keswick</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?93e56cfc